"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const generic_1 = __importDefault(require("./generic"));
const closeAttrs = {
    x1: '30',
    x2: '70',
    strokeWidth: '1',
    strokeLinecap: 'butt',
    vectorEffect: 'non-scaling-stroke'
};
const IconbuttonClose = props => (jsx_runtime_1.jsx(generic_1.default, Object.assign({}, props, { color: "grey3", variant: "outline" }, { children: jsx_runtime_1.jsxs("svg", Object.assign({ viewBox: "0 0 100 100", "aria-hidden": "true" }, { children: [jsx_runtime_1.jsx("line", Object.assign({}, closeAttrs, { y1: "30", y2: "70" }), void 0),
            jsx_runtime_1.jsx("line", Object.assign({}, closeAttrs, { y1: "70", y2: "30" }), void 0)] }), void 0) }), void 0));
IconbuttonClose.propTypes = {
    onClick: prop_types_1.default.func.isRequired,
    label: prop_types_1.default.string,
    buttonRef: prop_types_1.default.func,
    disabled: prop_types_1.default.bool
};
IconbuttonClose.defaultProps = {
    label: 'Close',
    disabled: false,
    buttonRef: null
};
exports.default = IconbuttonClose;
//# sourceMappingURL=close.js.map